import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierGuestSuiteController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierGuestSuiteController.php
* @route '/api/dossier/{dossier}/guest-suite'
*/
const UpdateDossierGuestSuiteController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierGuestSuiteController.url(args, options),
    method: 'put',
})

UpdateDossierGuestSuiteController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/guest-suite',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierGuestSuiteController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierGuestSuiteController.php
* @route '/api/dossier/{dossier}/guest-suite'
*/
UpdateDossierGuestSuiteController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierGuestSuiteController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierGuestSuiteController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierGuestSuiteController.php
* @route '/api/dossier/{dossier}/guest-suite'
*/
UpdateDossierGuestSuiteController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierGuestSuiteController.url(args, options),
    method: 'put',
})

export default UpdateDossierGuestSuiteController